import type {
  CulturalObjectsSliderDynamic,
  SliderSectionBase,
} from "@shared/content-types/schemas/sections.schema";

import type { CulturalObject } from "@/_pages/cultural-objects/model/types";

const mapCulturalObjectToSliderCardForSection = (
  culturalObject: CulturalObject,
): SliderSectionBase["sliders"][number]["sliderCards"][number] => {
  const firstType = culturalObject.cultural_object_type;

  const iconProps =
    firstType?.uid === "natural"
      ? {
          icon: {
            name: "plant" as const,
          },
          fillColor: "azure" as const,
        }
      : {
          icon: {
            name: "skulp" as const,
          },
          fillColor: "violet" as const,
        };

  return {
    id: culturalObject.id,
    title: culturalObject.title,
    description: culturalObject.description ?? null,
    image: culturalObject.backgroundImage ?? null,
    location: culturalObject.location ?? null,
    time: culturalObject.travelTime ?? null,
    link: `/cultural-objects/${culturalObject.uid}`,
    icon: {
      id: 1,
      ...iconProps,
      strokeColor: "white",
      uicon: null,
    },
  };
};

export const mapCulturalObjectsSliderToSliderSection = (
  block: CulturalObjectsSliderDynamic & {
    cultural_objects?: CulturalObject[];
  },
): SliderSectionBase["sliders"] => {
  const rawObjects: CulturalObject[] =
    block.cultural_objects ??
    (block.cultural_object ? [block.cultural_object as CulturalObject] : []);

  const sliderCards = rawObjects.map(mapCulturalObjectToSliderCardForSection);

  return [
    {
      id: block.id,
      subtitle: block.subtitle,
      title: block.title,
      description: null,
      button: null,
      buttonIcon: null,
      sliderCards,
    },
  ];
};
